<template>
  <div class="header flex vertical space-between">
    <div class="flex vertical">
      <div class="logo"></div>
    </div>
    <div class="user flex vertical">
      <el-dropdown @command="changeLang" class="m-r-10">
        <span class="el-dropdown-link pointer">
          {{currentLang}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="en">English</el-dropdown-item>
          <el-dropdown-item command="zh-CN">简体中文</el-dropdown-item>
          <el-dropdown-item command="zh-TW">繁体中文</el-dropdown-item>
          <el-dropdown-item command="it">Italian</el-dropdown-item>
          <el-dropdown-item command="id">Indonesia</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dropdown @command="command">
        <span class="el-dropdown-link pointer">
          {{real_name}}
          <i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="1">{{$t('back')}}</el-dropdown-item>
          <el-dropdown-item command="2">{{$t('logout')}}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.header {
  width: 100%;
  padding: 8px 20px;
  background: #00c4aa;
}
.logo {
  color: #fff;
  width: 155px;
  height: 44px;
  font-size: 24px;
  line-height: 44px;
  font-weight: 200;
  background: url('~@/common/image/logoWhite.png') no-repeat;
  background-size: cover;
}
h1 {
  font-weight: 200;
}
.avatar {
  display: inline-block;
  text-align: center;
  background: #ccc;
  color: #fff;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  vertical-align: middle;
  width: 32px;
  height: 32px;
  border-radius: 16px;
  line-height: 32px;
}
.avatar-name {
  color: white;
}
span {
  font-size: 12px;
}
.el-dropdown-link {
  color: #fff;
}
.mar {
  overflow: hidden;
  flex: 1;
  padding: 0 80px;
}
.guide {
  font-size: 12px;
  color: white;
  cursor: pointer;
  margin-top: 15px;
  margin-left: 15px;
  &:hover {
  }
}
</style>

<script>
import lang from '@/common/json/lang'

export default {
  inject: ['iPath'],
  created() {
    this.getUserInfo()
  },
  computed: {
    locale() {
      return this.$store.state.locale
    },
    currentLang() {
      return lang[this.$store.state.locale]
    },
    real_name() {
      return this.$store.state.user.real_name
    },
    sourcePath() {
      const reg = /^(\/(zh-CN|zh-TW|it|id))/
      return this.$route.fullPath.replace(reg, '')
    }
  },
  methods: {
    getUserInfo() {
      const store = this.$store
      if (store.state.token) {
        store.dispatch('getUserInfo')
      }
    },
    changeLang(la) {
      const fullPath = this.$route.fullPath
      let path
      if (la === 'en') {
        path = fullPath.replace(/^\/[^/]+/, '')
      } else {
        path = this.locale === la ? fullPath : '/' + la + this.sourcePath
      }
      this.$router.push(path)
    },
    command(command) {
      switch (command) {
        case '1':
          this.goBack()
          break
        case '2':
          this.logout()
          break
      }
    },
    async logout() {
      await API.get('/edu/zone/exit')
      this.$store.commit('LOGOUT')
      this.$router.push(this.iPath('/login'))
    },
    async goBack() {
      this.$router.replace(this.iPath('/'))
    },
    showGuide() {
      this.$emit('play')
    }
  }
}
</script>
<i18n lang="yaml">
en:
  back: Return to homepage
  logout: Log out
zh-CN:
  back: 回到首页
  logout: 退出登录
zh-TW:
  back: 回到首页
  logout: 退出登錄
it:
  back: Torna alla homepage
  logout: Esci
id:
  back: Kembali ke beranda
  logout: Keluar
</i18n>
